import { Navigate } from 'react-router-dom';

import { useSectionAccess } from '@/shared/navigation/useSectionAccess';

import { HomePage } from '@/app/pages/HomePage';
import { NoAccessPage } from '@/app/pages/NoAccessPage';

/**
 * What `/` resolves to, decided by what the user may actually see.
 *
 * <p>Three outcomes, in order:
 *
 * <ol>
 *   <li>Can read the commerce data the dashboard summarises → the dashboard.</li>
 *   <li>Cannot, but has some other section → straight to it. A warehouse-only account lands on the
 *       stock workspace rather than on a revenue summary it has no right to read.</li>
 *   <li>Has nothing → {@link NoAccessPage}, which explains why and who can fix it.</li>
 * </ol>
 *
 * <p>The redirect `replace`s rather than pushes: `/` is not a place such a user can stay, and leaving it
 * in history would make Back bounce them forward again.
 */
export function HomeRoute() {
  const { canEnter, fallback } = useSectionAccess();

  if (canEnter('dashboard')) {
    return <HomePage />;
  }
  if (fallback) {
    return <Navigate to={fallback.path} replace />;
  }
  return <NoAccessPage />;
}
